import { render } from "./TabListMailDelete.vue?vue&type=template&id=47574721"
import script from "./TabListMailDelete.vue?vue&type=script&lang=js"
export * from "./TabListMailDelete.vue?vue&type=script&lang=js"

import exportComponent from "/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__